import ModalBlock from './index'
export default {
  ModalBlock,
}
